export const ATTENTIVEDRIVINGVALUETRANSLATOR: Record<string, string> = {
    'higher': 'ALTO',
    'lower': 'BAIXO'
};